import React from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { Hero, Section, Cards, CTA, Steps, FAQ } from "../components/Page/Page.js";
import { projects, services, faqs } from "../data/content.js";
import ProjectMap from "../components/Page/ProjectMap.js";

export default function DetailScreen({ list }) {
  const { slug } = useParams();
  const isProject = list === "projects";
  const item = (isProject ? projects : services).find((p) => p.slug === slug);
  if (!item) return <Navigate to="/404" replace />;
  const related = (isProject ? projects : services).filter((p) => p.slug !== slug).slice(0, 3);
  return (
    <>
      <Hero eyebrow={isProject ? `Projects / ${item.status}` : "Services"} title={item.title} text={item.tagline} image={item.image} cta="Book a discovery call" />
      <Section><p>{item.intro}</p></Section>
      <Section title={isProject ? "Why it matters" : "What you get"} n="01" alt>
        <Cards items={item.points} />
      </Section>
      {isProject && item.facts && (
        <Section title="Project facts">
          <dl className="pg-facts">
            {item.facts.filter(([, v]) => v !== "TODO").map(([k, v]) => <div key={k}><dt>{k}</dt><dd>{v}</dd></div>)}
          </dl>
        </Section>
      )}
      {isProject && item.coords && (
        <Section title="Location" alt><ProjectMap coords={item.coords} title={item.title} /></Section>
      )}
      {isProject && item.sdgs && (
        <Section title="UN Sustainable Development Goals" alt>
          <div className="pg-chips">{item.sdgs.map((n) => <span className="pg-chip" key={n}>SDG {n}</span>)}</div>
        </Section>
      )}
      <Section title="How we work with you"><Steps /></Section>
      <Section title="Common questions" alt><FAQ items={faqs.slice(0, 4)} /></Section>
      <Section title={isProject ? "More projects" : "More services"}>
        <div className="pg-links">
          {related.map((r) => <Link key={r.slug} to={`/${list}/${r.slug}`}>{r.title} →</Link>)}
        </div>
      </Section>
      <CTA />
    </>
  );
}
